/**
 * How rich text looks, in the editor and the view alike: the reset Tailwind applies to lists,
 * headings and links undone, in the theme's colors.
 */
export const proseClasses = [
  'text-sm text-text-primary break-words',
  '[&_p]:my-2 [&_h1]:my-3 [&_h2]:my-3 [&_h3]:my-2 [&_h4]:my-2 [&_h5]:my-2 [&_h6]:my-2',
  '[&_h1]:font-heading [&_h1]:text-2xl [&_h2]:font-heading [&_h2]:text-xl [&_h3]:font-heading [&_h3]:text-lg [&_h4]:font-medium',
  '[&_h5]:font-medium [&_h5]:text-text-secondary [&_h6]:font-medium [&_h6]:text-xs [&_h6]:text-text-secondary',
  '[&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_li_p]:my-0.5',
  '[&_a]:text-primary-main [&_a]:underline',
  '[&_blockquote]:my-2 [&_blockquote]:border-l-4 [&_blockquote]:border-divider [&_blockquote]:pl-4 [&_blockquote]:text-text-secondary',
  '[&_hr]:my-4 [&_hr]:border-divider',
  '[&_code]:rounded [&_code]:bg-background-contrast-sm [&_code]:px-1 [&_code]:font-mono',
  '[&_pre]:my-2 [&_pre]:overflow-x-auto [&_pre]:rounded [&_pre]:bg-background-contrast-sm [&_pre]:p-3 [&_pre_code]:bg-transparent [&_pre_code]:p-0',
].join(' ')
